// Shared cancellation boundary; contains no store or HTTP imports.
let generation = 0;
let abort = new AbortController();
const listeners = new Set();
export const sessionGeneration = () => generation;
export const sessionSignal = () => abort.signal;
export function endLocalSession() {
  generation += 1;
  abort.abort();
  abort = new AbortController();
  for (const listener of listeners) listener();
}
export function onSessionEnd(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
export function sessionCancelled() {
  return Object.assign(new Error("Session ended"), { code: "ERR_CANCELED" });
}
